import  types from "../actions/actionTypes";
import initialState from "./initialState";


export default function usersReducer(state = initialState.usersList, action) {

    const merge = (current, update) => {
        const updateIds = update.map(user => user.id);
        let result = current.map(user => {
            if (updateIds.includes(user.id)) {
                return update.find(up => up.id === user.id);
            }
            return user;
        });
        const existingIds = result.map(user => user.id);
        const newUsers = update.filter(user => !existingIds.includes(user.id));
        return [...result, ...newUsers];   
    }

    const deleteUser = (current, id) => {
        return current.filter(user => user.id !== id);
    } 

    switch (action.type) {
        case types.LOAD_USERS_SUCCESS:
            return action.usersList;
        case types.LOAD_USERS_UPDATE_SUCCESS:
            return merge(state, action.usersList);
        case types.DELETED_USER:    
            return deleteUser(state, action.id);
        case types.DELETED_USER_INCOMING:
            return deleteUser(state, action.payload);          
        default:
            return state;
    }
}

